/** 工作记录每一项组件
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import workIcon from "./img/workIcon.png";
import infor from "./img/infor.png";
import deleteIcon from "./img/delete.png";
import checked from "./img/checked.png";

export default class WorkItem extends Component {
    static defaultProps = {
        editStatus: false,
        chooseCallback: ()=>{},
        deleteBtnStatus:true,
    };
    static propTypes = {
        title: PropTypes.string.isRequired,//标题
        num: PropTypes.number,//显示数
        editStatus: PropTypes.bool,//是否是编辑
        deleteCallback: PropTypes.func,//删除方法回调
        chooseCallback: PropTypes.func,// 选择回调
        checked: PropTypes.bool,//是否选中
        deleteBtnStatus:PropTypes.bool,//是否展示删除按钮
        mark:PropTypes.string,//叹号提示内容
    };

    constructor(props) {
        super(props);
        this.state = {
            choose: false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div style={{background:'#f8fafd'}}>
                <div onClick={() => {
                    if (this.props.chooseCallback) {
                        this.props.chooseCallback()
                    }
                }} style={{
                    height: 110,
                    display: 'flex',
                    border: '1px solid #e9e9e9',
                    padding: 20,
                    position: 'relative',
                    borderColor: this.props.checked ? '#b292ee' : '#e9e9e9'
                }}>
                    <div style={{display: 'flex'}}><img src={workIcon} style={{height: 56, width: 56, margin: 'auto'}}
                                                        alt=""/></div>
                    <div style={{margin: 'auto'}}>
                        <div style={{fontSize: 14, color: '#929292', textAlign: 'left',width:100,overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'}} title={this.props.title}>{this.props.title}</div>
                        <div style={{fontSize: 18, color: '#272727', textAlign: 'left'}}>{this.props.num}</div>
                    </div>
                    {this.props.editStatus ? <div>
                        <div style={{position: 'absolute', top: 10, right: 10,cursor:'pointer'}}>
                            <img src={infor} style={{width: 20, height: 20}} alt="" title={this.props.mark}/>
                        </div>
                        {this.props.deleteBtnStatus? <div style={{position: 'absolute', right: -2, bottom: -2, color: 'blue', cursor: 'pointer'}}
                                                          onClick={() => {
                                                              this.props.deleteCallback()
                                                          }}>
                            <img src={deleteIcon} style={{width: 30, height: 30}} alt=""/>
                        </div>:null}

                    </div> : null}
                    {
                        this.props.checked?<div style={{position: 'absolute', right: -2, bottom: -2, color: 'blue', cursor: 'pointer'}}
                                                onClick={() => {
                                                }}>
                            <img src={checked} style={{width: 30, height: 30}} alt=""/>
                        </div>:null
                    }


                </div>

            </div>
        )
    }

}